import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const unread = items.filter((n) => !n.read).length;

  const load = () => api.get("/notifications").then(({ data }) => setItems(data || []));
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  const openItem = async (n) => {
    if (!n.read) { await api.put(`/notifications/${n.notif_id}/read`); load(); }
    if (n.link) navigate(n.link);
  };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative h-9 w-9 rounded-lg border border-slate-200 bg-white flex items-center justify-center hover:bg-slate-50" data-testid="notif-bell">
          <Bell className="h-4.5 w-4.5 text-slate-600" />
          {unread > 0 && <span className="absolute -top-1 -right-1 h-4 min-w-4 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between p-3 border-b border-slate-100">
          <span className="font-semibold text-sm">Notifications</span>
          {unread > 0 && <button onClick={markAll} className="text-xs text-primary">Tout marquer comme lu</button>}
        </div>
        <div className="max-h-80 overflow-auto custom-scroll">
          {items.length === 0 && <p className="p-6 text-center text-sm text-slate-400">Aucune notification</p>}
          {items.map((n) => (
            <button key={n.notif_id} onClick={() => openItem(n)} className={`w-full text-left p-3 border-b border-slate-50 hover:bg-slate-50 ${!n.read ? "bg-primary/5" : ""}`}>
              <p className="text-sm font-medium text-slate-800">{n.title}</p>
              {n.body && <p className="text-xs text-slate-500 mt-0.5 line-clamp-2">{n.body}</p>}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
